import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { useIsMobile } from 'hooks/useIsMobile';
import SignUpIntroduction from './components/AuthComponents/SignUpIntroduction';
import SignUpIntroductionMobile from './components/AuthComponents/SignUpIntroduction/introduction.mobile';

type TPortalProps = {
  children: ReactNode;
};

const Portal: FC<TPortalProps> = ({ children }) => {
  const isMobile = useIsMobile(960);

  return (
    <SRoot>
      {isMobile ? (
        <SWelcomeMobile>
          <SignUpIntroductionMobile />
        </SWelcomeMobile>
      ) : (
        <SWelcome>
          <SignUpIntroduction />
        </SWelcome>
      )}
      <SFormPanel>
        <SPaper>{children}</SPaper>
      </SFormPanel>
    </SRoot>
  );
};

export default Portal;

const SRoot = styled.main`
  display: flex;
  height: 100vh;
  width: 100%;

  @media (max-width: 960px) {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }
`;

const SWelcome = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  background-color: #fcc425;
  display: flex;
  align-items: center;
  font-family: 'aesthet-nova', serif;
`;

const SWelcomeMobile = styled.div`
  width: 100%;
  background-color: #fcc425;
  display: flex;
  align-items: center;
  font-family: 'aesthet-nova', serif;
`;

const SFormPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: #ffffff;

  @media (max-width: 960px) {
    align-items: flex-start;
    min-height: calc(100vh - 73px);
  }
`;

const SPaper = styled.div`
  margin: 16px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 960px) {
    margin: 32px 16px;
  }
`;
